{
  "columns": [
    {
      "header_id": "batchInstanceId",
      "header_label": "Batch ID",
      "jsonpath": "batchInstanceId",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "payrollBatchNo",
      "header_label": "Payroll Batch No",
      "jsonpath": "payrollBatchNo",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "batchType",
      "header_label": "Batch Type",
      "jsonpath": "batchType",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "batchStatus",
      "header_label": "Status",
      "jsonpath": "batchStatus",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "modifiedByName",
      "header_label": "Modified By",
      "jsonpath": "modifiedByName",
      "isDisplayedAtHeader": "y",
      "isSearchable": "y"
    },
    {
      "header_id": "modifiedDate",
      "header_label": "Modified Date",
      "jsonpath": "modifiedDate",
      "isDisplayedAtHeader": "y",
      "isSearchable": "n"
    }
  ],
  "buttons": [
    {
      "button_id": "Approve",
      "button_label": "Approve",
      "buttonAction": "approvePayrollRun",
      "className": "primary"
    },
    {
      "button_id": "Reject",
      "button_label": "Reject",
      "buttonAction": "rejectPayrollRun",
      "className": "primary-btn-color"
    }
  ],
  "apiDetails": "timesheet-payroll-run-list.json",
  "pageName": "payroll-processing",
  "orderByColumn": ["batchInstanceId"],
  "orderBy": ["desc"]
}
